import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo/camera.svg'


const _withScopeId = n => (_pushScopeId("data-v-c483a82c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-[768px] h-full min-h-screen bg-red-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-4 font-bold text-lg justify-between flex" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "" }, "자유게시판 글쓰기")
], -1))
const _hoisted_3 = { class: "w-full flex-wrap flex" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { for: "file" }
const _hoisted_6 = { class: "btn-upload mr-4 mb-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-6 h-6"
}, null, -1))
const _hoisted_8 = { class: "text-xs mt-1 text-[#898989]" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-[2px]" }, "×", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border-solid border-b border-zinc-100 my-8" }, null, -1))
const _hoisted_14 = { class: "flex flex-col space-y-4" }
const _hoisted_15 = { class: "flex items-center font-medium" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 text-lg" }, [
  /*#__PURE__*/_createTextVNode("제목"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-pada" }, "*")
], -1))
const _hoisted_17 = { class: "flex items-start font-medium" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 mt-2 text-lg" }, [
  /*#__PURE__*/_createTextVNode("내용"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-pada" }, "*")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-40" }, null, -1))

import { ref, reactive } from 'vue';
import imageCompression from "browser-image-compression";
import { BoardApi } from '@/api/api';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'BoardWrite',
  setup(__props) {

const router = useRouter();
const thumbnail = ref([ ]);

const formData = reactive({
    user_id : 'padamasterc',
    title :'',
    content : '',
    category : 1,
    images : []

});

// 이미지 압축하기 
const compressImage = async (file) => {
    const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
    };
    return await imageCompression(file, options);
};
// 이미지 업로드 
const upload = async (e: Event) => {
    const input = e.target as HTMLInputElement;
    if (input.files) {
        const files = Array.from(input.files).slice(0, 10); // 최대 10개의 파일만 선택
        for (let file of files) {
            const url = URL.createObjectURL(file);
            thumbnail.value.push(url); // 미리보기용 URL 추가
            formData.images.push(file); // 실제 파일을 formData에 추가
        }
    }
};

// 이미지 삭제
const deletePhoto = (item :string) => {
    thumbnail.value = thumbnail.value.filter(img => img !== item)
};

const submitData = async () => {
    if(formData.images.length > 0) {
       await submitIncludeImage();
    }else {
       await submitOnlyText();
    }
    router.push('/community')
};

// 게시글 only 텍스트
const submitOnlyText = async () => {
    console.log('날라가는거 확인', formData)
    //서버에 FormData 전송
    try {
        const response = await BoardApi.addPostText(
            formData.user_id, 
            formData.title, 
            formData.content, 
            formData.category, 
        );
        // console.log(response)
    } catch (error) {
        console.log(error)
    }
};
// 게시글 이미지 포함
// 데이터 제출 함수
const submitIncludeImage = async () => {
    const form = new FormData();

    // 기본 필드 추가
    form.append('user_id', formData.user_id);
    form.append('title', formData.title);
    form.append('content', formData.content);
    form.append('category', formData.category.toString());

    // 이미지 파일 추가
    for (const [index, image] of formData.images.entries()) {
        // 0번 인덱스 이미지 파일, 압축하고 썸네일로 복사하기
        if (index === 0) {
            try {
                const compressedFile = await compressImage(image);
                // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`);
                form.append('uploadfiles', compressedFile, `thumbnail.jpg`);
            } catch (error) {
                console.log(error);
            }
        }
        form.append('uploadfiles', image, `imgURL${index}.jpg`);
    }

    // 서버에 FormData 전송
    try {
        const response = await BoardApi.addPostImages(form);
        // console.log(response);
    } catch (error) {
        console.error(error);
    }
};


// watch(setFilter,submit);

// const checkContNull = () => {
//     if(selectJong.value === null){

//     } else {
//         isNull.value = false
//     }

// }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, "(" + _toDisplayString(thumbnail.value.length) + "/10)", 1)
          ])
        ]),
        _createElementVNode("input", {
          type: "file",
          name: "file",
          id: "file",
          onChange: upload,
          multiple: ""
        }, null, 32)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(thumbnail.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "previewImg relative mr-4 mb-4"
        }, [
          _createElementVNode("img", {
            src: item,
            alt: "",
            class: "w-full h-full object-cover rounded-xl"
          }, null, 8, _hoisted_9),
          _createElementVNode("div", {
            class: "bg-[#17181a] w-6 h-6 rounded-full absolute -top-2 -right-2 flex justify-center items-center font-light cursor-pointer text-white",
            onClick: ($event: any) => (deletePhoto(item))
          }, _hoisted_12, 8, _hoisted_10)
        ]))
      }), 128))
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _withDirectives(_createElementVNode("input", {
          class: "w-11/12 h-10 pl-4 border border-solid border-[#D6D6D6] rounded-md text-sm font-normal placeholder:text-sm placeholder:text-zinc-300 placeholder:font-light focus:border-[#1B1B1D]",
          placeholder: "제목을 입력해주세요",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.title) = $event))
        }, null, 512), [
          [_vModelText, formData.title]
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _withDirectives(_createElementVNode("textarea", {
          class: "w-11/12 p-4 border border-solid border-[#D6D6D6] rounded-md resize-none text-sm font-normal placeholder:text-sm placeholder:text-zinc-300 placeholder:font-light focus:border-[#1B1B1D]",
          cols: "30",
          rows: "10",
          placeholder: "상세 내용을 입력해주세요",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.content) = $event))
        }, null, 512), [
          [_vModelText, formData.content]
        ])
      ])
    ]),
    _createElementVNode("div", { class: "w-full flex justify-end mt-8" }, [
      _createElementVNode("button", {
        class: "w-28 h-10 bg-pada text-white text-sm rounded-lg",
        onClick: submitData
      }, " 등록 ")
    ]),
    _hoisted_19
  ]))
}
}

})